import { render, staticRenderFns } from "./BookShow.vue?vue&type=template&id=0d912c27&scoped=true"
import script from "./BookShow.vue?vue&type=script&lang=js"
export * from "./BookShow.vue?vue&type=script&lang=js"
import style0 from "./BookShow.vue?vue&type=style&index=0&id=0d912c27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d912c27",
  null
  
)

export default component.exports